'use client';

import { TrackedAnchor } from '@/components/ancher';
import CtaBox, {
  CTA_BOX_BUTTON_CLASSNAME,
  CTA_BOX_BUTTON_TEXT_CLASSNAME,
} from './cta-box';

// 버튼 클릭 추적 라벨 prefix (다중 삽입 시 _1, _2 로 구분)
const CTA_WITH_INFO_LABEL = 'blog_cta_with_info';

export interface CtaWithInfoProps {
  /** 박스 제목 */
  title: string;
  /** 제목 아래 보조 문구. 없으면 그 줄 자체가 렌더되지 않는다 */
  description?: string;
  /** 버튼에 보일 문구 */
  label: string;
  /** 버튼이 여는 주소. 외부 링크면 TrackedAnchor 가 새 탭·rel 을 알아서 붙인다 */
  link: string;
  index: number;
}

/**
 * 본문 안에 들어가는 범용 CTA 박스 (Figma 2635:65339).
 *
 * 문의·케이스리뷰 CTA 와 생김새는 같지만 넷 다 MDX 작성자가 정한다 — 문구가
 * i18n 에 없으므로 **작성자가 로케일별 본문에 각각 맞는 문구를 써야 한다.**
 * 고정 문구를 여러 글에서 반복해 쓸 거라면 i18n 에 넣고 전용 컴포넌트를
 * 만드는 쪽이 맞다.
 *
 * 버튼이 모달·퍼널이 아니라 링크라 `TrackedAnchor` 를 쓴다.
 */
const CtaWithInfo = ({
  title,
  description,
  label,
  link,
  index,
}: CtaWithInfoProps) => (
  <CtaBox title={title} description={description}>
    {/* no-underline 은 본문 링크 밑줄(mdx-container.css `.blog a:not(.cta-button)`)을
        끄는 탈출구다 — 문의·케이스리뷰 CTA 는 button 이라 걸리지 않지만 이건 a 다.
        공용 상수에 넣지 않는 이유는 button 쪽에는 의미 없는 클래스이기 때문이다. */}
    <TrackedAnchor
      href={link}
      label={`${CTA_WITH_INFO_LABEL}_${index + 1}`}
      position="main_cta"
      className={`${CTA_BOX_BUTTON_CLASSNAME} no-underline`}
    >
      <span className={CTA_BOX_BUTTON_TEXT_CLASSNAME}>{label}</span>
    </TrackedAnchor>
  </CtaBox>
);

export default CtaWithInfo;
